import { useState } from "react";
import { ProjectList } from "./ProjectList";
import { Workspace } from "./Workspace";
import { AuthBar } from "./AuthBar";
import type { MeResult } from "../lib/api";

// The creator tool, served at /studio. Project open/close is local state (no per-project
// routing). The top-level hub-vs-studio split lives in App's path router.
export function Studio({
  me,
  refreshMe,
  onOpenSettings,
  navigate,
}: {
  me: MeResult | null;
  refreshMe: () => void;
  onOpenSettings: () => void;
  navigate: (to: string) => void;
}) {
  // Open a specific project if arrived via /studio?open=<id> (e.g. just forked from the hub).
  const [projectId, setProjectId] = useState<string | null>(() => {
    try {
      const open = new URLSearchParams(window.location.search).get("open");
      if (open) {
        // Clean the query so a refresh doesn't re-pin it.
        window.history.replaceState({}, "", "/studio");
        return open;
      }
    } catch {
      // ignore
    }
    return null;
  });

  if (projectId) {
    return (
      <Workspace
        projectId={projectId}
        onBack={() => setProjectId(null)}
        onOpenSettings={onOpenSettings}
      />
    );
  }

  return (
    <div className="shell">
      <div className="topbar">
        <div className="title title-link" onClick={() => navigate("/")} title="Back to the hub">quikpl.ai</div>
        <div className="spacer" />
        <button className="btn-ghost" onClick={() => navigate("/")} title="Browse the public hub">
          Hub
        </button>
        <AuthBar user={me?.user ?? null} onChanged={refreshMe} />
        <button className="btn-ghost" onClick={onOpenSettings} title="Settings">⚙</button>
      </div>
      {me && !me.user && (
        <div className="auth-nudge">
          You&rsquo;re working as a guest.{" "}
          <button className="linklike" onClick={() => (window.location.href = "/auth/google/start")}>
            Sign in
          </button>{" "}
          to keep your apps across devices.
        </div>
      )}
      <ProjectList onOpen={(id) => setProjectId(id)} />
    </div>
  );
}
